import { render } from "./RemoveThemeModal.vue?vue&type=template&id=3280790d&scoped=true"
import script from "./RemoveThemeModal.vue?vue&type=script&lang=js"
export * from "./RemoveThemeModal.vue?vue&type=script&lang=js"

import "./RemoveThemeModal.vue?vue&type=style&index=0&id=3280790d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3280790d"]])

export default __exports__